import { createSelector } from 'reselect';

import { SITE_ROOT_FOLDER_NAMES } from 'lib/const';

import cwdSiteRootFolderIdSelector from './cwdSiteRootFolderId';

export default createSelector(
  cwdSiteRootFolderIdSelector,
  cwdSiteRootFolderId => SITE_ROOT_FOLDER_NAMES[cwdSiteRootFolderId]
);
